import React from "react";

function intro(){
    return(
        <div className="text-center p-10">
            <h2 className="text-5xl py-2 text-teal-600 font-medium">
              Mohith Jothi Kannan
            </h2>
            <h3 className="text-2xl py-2">Software Developer</h3>
            <p className="text-md mx-[150px] leading-8 text-gray-700">
              I'm a graduate student currently pursuing my Master of Computer
              Science at Arizona State University, Tempe. I have experience in Full Stack development and
              Database Engineering. Currently looking for full time opportunities in the United States.
            </p>
        </div>
    );
};

export default intro;